import React from "react";
import CommonPage from "../common/CommonPage";
import Loading from "../../../common/loading/loading";

const LoadingPage = () => {

	return <CommonPage><Loading/></CommonPage>;

}

export default LoadingPage;